export default __webpack_public_path__ + "static/media/ClinicAppointment.eb97ea33.svg";